import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import {
  AddImages,
  ImageCrop
} from '../../components';
import css from './EditListingDescriptionForm.module.css';
import classNames from 'classnames';


const replaceFileName = (file, newName) => {
  let parts = file.name.split('.');
  let ext = parts.pop();
  let changed = new File([file], newName, {
    //+ '.' + ext ->add this after 'newName'  if we want to add the extension too
    type: file.type,
    lastModified: file.lastModified,
  });
  return changed;
};

const ACCEPT_IMAGES = 'image/*';

export class LogoPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCrop: false,
    };
  }

  handleShowCrop = (e, key) => {
    e.preventDefault();
    this.setState({ showCrop: true }, () => this.setState({ showCrop: false }))
  }

  render() {

    const {
      isMobSaf,
      form,
      publicData,
      images,
      intl,
      imageUploadRequested,
      onImageUploadHandler,
      onRemoveImage,
      handleSubmitFile,
      handleCloseCropPopup,
      isRequired,
    } = this.props

    const { showCrop } = this.state;

    const imagesConfig = {
      label: 'Logo',
      key: 'logoPhoto',
      placeholder: '+ Add Logo',
      placeholderReplace: '+ Replace Logo',
      countLimit: 1,
      photoIdKey: 'logoPhotoIds',
    };

    const label = imagesConfig.label;
    const key = imagesConfig.key;
    const placeholder = imagesConfig.placeholder;
    const placeholderReplace = imagesConfig.placeholderReplace;
    const countLimit = imagesConfig.countLimit;

    const imagesArray = images;
    const showAddImageField = images?.length < 2;
    
    return (
      <>
        <p className={classNames(css.fieldLabel, {[css.isRequired]: isRequired})}>{label}</p>
        <AddImages
          key={key}
          className={css.imagesField}
          images={imagesArray}
          thumbnailClassName={classNames(css.thumbnail, css.thumbnailLogo)}
          savedImageAltText={intl.formatMessage({
            id: 'EditListingPhotosForm.savedImageAltText',
          })}
          onRemoveImage={onRemoveImage}
          imageKey={key}
        >
          {showAddImageField && (
            <Field
              id={key}
              name={key}
              accept={ACCEPT_IMAGES}
              form={null}
              label={images?.length >= 1 ? placeholderReplace : placeholder}
              type="file"
              disabled={imageUploadRequested}
            >
              {fieldprops => {
                const { accept, input, label, disabled: fieldDisabled } = fieldprops;
                const { name, type, index } = input;
                const onChange = e => {
                  const file = e.target.files[0];
                  const newFile = replaceFileName(file, key);

                  form.change(key, newFile);
                  form.blur(key);

                  onImageUploadHandler(newFile);
                };
                // const inputProps = { accept, id: name, name, onChange, type };

                const inputProps = {
                  id: name,
                  name,
                  type,
                  accept,
                  ...(isMobSaf ? {
                    onChange: e => {
                      // const file = e.target.files[0];
                      // form.change(`addImage`, file);
                      // form.blur(`addImage`);
                      // onImageUploadHandler(file);
                      const file = e.target.files[0];
                      const newFile = replaceFileName(file, key);

                      form.change(key, newFile);
                      form.blur(key);

                      onImageUploadHandler(newFile);
                    }
                  } : {
                    onClick: e => this.handleShowCrop(e, key)
                  })
                };

                return (
                  <div className={css.addImageWrapper}>
                    <div className={css.aspectRatioWrapper}>
                      {fieldDisabled ? null : (
                        <input {...inputProps} className={css.addImageInput} />
                      )}
                      <label
                        htmlFor={name}
                        className={css.addImage}
                      >
                        {label}
                      </label>
                    </div>
                  </div>
                );
              }}
            </Field>
          )}

          <Field
            component={props => {
              const { input, meta } = props;
              return (
                <div className={css.imageRequiredWrapper}>
                  <input {...input} />
                </div>
              );
            }}
            name="images"
            type="hidden"
          />
        </AddImages>

        <ImageCrop
          key="ImageCrop.logoPhoto"
          isOpen={showCrop}
          submitFile={file => handleSubmitFile(file, "logoPhoto")}
          onClose={handleCloseCropPopup}
          namePrefix="logoPhoto"
          aspect={1/1}
          minWidth={100}
          minHeight={100}
        />
      </>
    );
  }
}

LogoPhoto.defaultProps = { fetchErrors: null, images: [] };

LogoPhoto.propTypes = {
  fetchErrors: shape({
    publishListingError: propTypes.error,
    showListingsError: propTypes.error,
    uploadImageError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  images: array,
  intl: intlShape,
  onImageUpload: func,
  onUpdateImageOrder: func,
  onSubmit: func,
  saveActionMsg: string,
  disabled: bool,
  ready: bool,
  updated: bool,
  updateInProgress: bool,
  onRemoveImage: func,
};

export default compose(injectIntl)(LogoPhoto);